module.exports = __webpack_public_path__ + "static/fonts/Mont-Bold.efd54e7.ttf";